import { object, string, array, number, bool } from "yup";
import { APPLICATION_ID, RoleV2Id } from "@/types";

export const createUserV2Schema = (canvasZipApplicationId?: number) =>
  object({
    active: bool().default(true),
    name: string().required("Name is required"),
    email: string().email("Invalid email").required("Email is required"),
    roles: array()
      .of(
        object({
          roleId: number()
            .min(1, "This field is required")
            .required("Role ID is required"),
          appId: number()
            .min(1, "This field is required")
            .required("App ID is required"),
          regionTags: array()
            .of(number().required())
            .when(["appId", "roleId"], {
              is: (appId: number, roleId: number) =>
                (appId === APPLICATION_ID.FAST_MK2 ||
                  appId === APPLICATION_ID.PLATFORM) &&
                roleId !== RoleV2Id.PLATFORM_SUPER_ADMIN,
              then: (schema) =>
                schema
                  .min(1, "This field is required")
                  .required("This field is required"),
              otherwise: (schema) => schema.notRequired().nullable(),
            }),
          stateTags: array()
            .of(number().required())
            .when("appId", {
              is: (appId: number) =>
                canvasZipApplicationId !== undefined &&
                appId === canvasZipApplicationId,
              then: (schema) =>
                schema
                  .min(1, "This field is required")
                  .required("This field is required"),
              otherwise: (schema) => schema.notRequired().nullable(),
            }),
          marketTags: array().of(number()),
          tags: array().of(number().required()).required(),
        }).required("Role is required"),
      )
      .required("Roles are required"),
    tags: array().of(number().required()).required(),
    providerName: string().when("roles", {
      is: (roles: { roleId: number }[] = []) =>
        roles.some(
          (r) =>
            r.roleId === RoleV2Id.FAST_MK2_BASIC_PROVIDER ||
            r.roleId === RoleV2Id.FAST_MK2_ADVANCED_PROVIDER,
        ),
      then: (Schema) => Schema.required("This field is required"),
      otherwise: (Schema) => Schema.notRequired().nullable(),
    }),
  });

export const userV2SchemaSimplified = object({
  active: bool().default(true),
  name: string().required("This field is required"),
  email: string().when("roles.0.roleId", {
    is: (roleId: number) =>
      [RoleV2Id.FAST_MK2_FLEXPERT, RoleV2Id.FAST_MK2_FLEXPERT_SUPPORT].includes(
        roleId,
      ),
    then: (schema) =>
      schema
        .required("This field is required")
        .matches(
          checkForCbreEmail,
          "Email should be in the correct format with CBRE domain",
        ),
  }),
  roles: array()
    .of(
      object({
        roleId: number()
          .min(1, "This field is required")
          .required("Role ID is required"),
        appId: number().required(),
        tags: array().of(number().required()),
        regionTags: array()
          .of(number().required())
          .min(1, "This field is required")
          .required("Region is required"),
        marketTags: array().of(number()),
      }),
    )
    .required("Role is required"),
  tags: array().of(number().required()).required(),
  providerName: string().when("roles.0.roleId", {
    is: (roleId: number) =>
      roleId === RoleV2Id.FAST_MK2_BASIC_PROVIDER ||
      roleId === RoleV2Id.FAST_MK2_ADVANCED_PROVIDER,
    then: (Schema) => Schema.required("This field is required"),
    otherwise: (Schema) => Schema.notRequired().nullable(),
  }),
});

export const checkForCbreEmail =
  /^(?!.*(@cbre\.com|@cbreim\.com).*\1)(.*(@cbre.com|@cbreim.com))$/;

export const checkForExternalEmail =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
